import { FilterFn } from "@tanstack/react-table";


export const multiSelectFilterFn: FilterFn<any> = (row, columnId, filterValue) => {
    const value = row.getValue(columnId);
    return filterValue.length === 0 || filterValue.includes(value);

};

export const getCellTooltipId = (rowIndex: number, cellId: string): string => {
    return `tooltip-${rowIndex}-${cellId}`;
};

